export const convertOrderBundleProducts = (products) => {
    const convertedProduct = []
    products?.forEach((item) => {
        if (item.bundleProductsCustomerPick?.length) {
            convertedProduct.push({ ...item, productName: "*** " + item.productName, isPack: true, })
            item.bundleProductsCustomerPick.forEach(i => {
                let varName = ""
                if (i.product?.option) {
                    const findVarName = i.product.option.variations.find(item => item.sku === i.productVarSku)
                    varName = findVarName.value
                }
                convertedProduct.push({ ...i, inPack: true, count: (i.count || 1) * item.count, productName: i.product?.name + (varName ? "-" + varName : "") })
            })
        } else {
            convertedProduct.push(item)
        }
    });
    return convertedProduct
}